<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">

        <!-- 操作按钮区域 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton(null)">
              <i class="el-icon-plus"></i>
              <span>新增分类</span>
            </el-button>
          </div>
        </div>

        <!-- 搜索筛选区域 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <el-form-item label="分类名称" class="form-item">
                  <div class="input-wrapper">
                    <el-input 
                      v-model="searchCondition.category_name" 
                      placeholder="输入分类名称" 
                      clearable
                      prefix-icon="el-icon-collection-tag">
                    </el-input>
                  </div>
                </el-form-item>
                
                <el-form-item label="是否启用" class="form-item">
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.category_status" 
                      placeholder="选择状态" 
                      clearable
                      prefix-icon="el-icon-check">
                      <el-option label="启用" value="1"></el-option>
                      <el-option label="禁用" value="0"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                
                <el-form-item label="顶端导航" class="form-item" style="margin-left: 20px;">
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.is_top" 
                      placeholder="选择类型" 
                      clearable
                      prefix-icon="el-icon-top">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                
                <el-form-item label="热门推荐" class="form-item" style="margin-left: 20px;">
                  <div class="input-wrapper">
                    <el-select 
                      v-model="searchCondition.is_hot" 
                      placeholder="选择类型" 
                      clearable
                      prefix-icon="el-icon-star-on">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                
                <el-form-item class="form-item" style="margin-left: 20px;">
                  <div class="button-group">
                    <el-button 
                      type="primary" 
                      class="search-btn"
                      @click="nodelist()">
                      <i class="el-icon-search"></i>
                      查询
                    </el-button>
                    <el-button 
                      class="reset-btn"
                      @click="resetSearch">
                      <i class="el-icon-refresh-left"></i>
                      重置
                    </el-button>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-tickets"></i>
              分类列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{list.length}} 条记录</span>
            </div>
          </div>
          
          <ApeTable 
            :data="list" 
            :loading="loadingStaus" 
            ref="apeTable" 
            highlight-current-row
            class="modern-table">
            
            <el-table-column
              slot="first-column"
              width="80"
              align="center"
              label="排序">
              <template slot-scope="scope">
                <div class="drag-wrapper">
                  <el-tooltip effect="dark" content="拖动排序" placement="top">
                    <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                      <i class="el-icon-rank"></i>
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="分类信息"
              min-width="200">
              <template slot-scope="scope">
                <div class="category-cell">
                  <div class="category-name">
                    <i class="el-icon-folder-opened"></i>
                    {{scope.row.category_name}}
                  </div>
                  <div class="category-link">
                    <i class="el-icon-link"></i>
                    {{scope.row.category_link}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="图标"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div class="icon-cell">
                  <span class="icon-display">
                    <i :class="scope.row.category_icon" v-if="scope.row.category_icon"></i>
                    <span v-else class="no-icon">无图标</span>
                  </span>
                  <div class="icon-code">{{scope.row.category_icon}}</div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="状态"
              width="100"
              align="center">
              <template slot-scope="scope">
                <div class="status-cell">
                  <el-switch 
                    v-model="scope.row.category_status" 
                    :active-value="'1'"
                    :inactive-value="'0'"
                    active-color="#67C23A"
                    inactive-color="#F56C6C"
                    class="status-switch"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                  <div class="status-text">
                    {{scope.row.category_status === '1' ? '已启用' : '已禁用'}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="热门推荐"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div class="hot-cell">
                  <el-switch 
                    v-model="scope.row.is_hot" 
                    :active-value="'1'"
                    :inactive-value="'0'"
                    active-color="#FF6B35"
                    inactive-color="#E0E0E0"
                    class="hot-switch"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                  <div class="hot-text">
                    <i class="el-icon-star-on" v-if="scope.row.is_hot === '1'"></i>
                    {{scope.row.is_hot === '1' ? '热门' : '普通'}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="顶端导航"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div class="top-cell">
                  <el-switch 
                    v-model="scope.row.is_top" 
                    :active-value="'1'"
                    :inactive-value="'0'"
                    active-color="#409EFF"
                    inactive-color="#E0E0E0"
                    class="top-switch"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                  <div class="top-text">
                    <i class="el-icon-top" v-if="scope.row.is_top === '1'"></i>
                    {{scope.row.is_top === '1' ? '导航' : '隐藏'}}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="SEO信息"
              min-width="250">
              <template slot-scope="scope">
                <div class="seo-cell">
                  <div class="seo-item">
                    <span class="seo-label">标题：</span>
                    <span class="seo-value">{{scope.row.seo_title}}</span>
                  </div>
                  <div class="seo-item">
                    <span class="seo-label">关键字：</span>
                    <span class="seo-value">{{scope.row.seo_keywords}}</span>
                  </div>
                  <div class="seo-item">
                    <span class="seo-label">描述：</span>
                    <span class="seo-value">{{scope.row.seo_description}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="描述"
              min-width="200">
              <template slot-scope="scope">
                <div class="desc-cell">
                  <i class="el-icon-document"></i>
                  {{scope.row.category_desc}}
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              v-if="buttonType=='icon'"
              label="操作"
              width="220"
              align="center">
              <template slot-scope="scope">
                <div class="action-cell">
                  <el-tooltip effect="dark" content="子分类" placement="top">
                    <el-button 
                      size="small" 
                      type="warning" 
                      icon="el-icon-arrow-down" 
                      class="table-action-btn sub-btn"
                      @click="getNode(scope.row.id)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="编辑分类" placement="top">
                    <el-button 
                      size="small" 
                      type="primary" 
                      icon="el-icon-edit" 
                      class="table-action-btn edit-btn"
                      @click="editButton(scope.row.id)">
                    </el-button>
                  </el-tooltip>
                  <el-popconfirm
                    title="确定删除该分类及其所有子分类吗？"
                    confirm-button-text="删除"
                    cancel-button-text="取消"
                    @confirm="deleteButton(scope.row.id)">
                    <el-button
                      slot="reference"
                      size="small"
                      type="danger"
                      icon="el-icon-delete"
                      class="table-action-btn delete-btn"
                      title="删除分类">
                    </el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>
    
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="menuForm" label-position="right" label-width="96px">
          <el-form-item label="名称" prop="category_name">
            <el-input v-model="formData.category_name"></el-input>
          </el-form-item>
          <el-form-item label="链接" prop="category_link">
            <el-input v-model="formData.category_link"></el-input>
          </el-form-item>
          <el-form-item label="ICON" prop="category_icon">
            <el-input v-model="formData.category_icon"></el-input>
          </el-form-item>
          <el-form-item label="附加内容" prop="category_desc">
            <el-input type="textarea" v-model="formData.category_desc"></el-input>
          </el-form-item>
          <el-form-item label="seo 标题" prop="seo_title">
            <el-input type="textarea" v-model="formData.seo_title"></el-input>
          </el-form-item>
          <el-form-item label="seo 关键字" prop="seo_keywords"> 
            <el-input type="textarea" v-model="formData.seo_keywords"></el-input>
          </el-form-item>
          <el-form-item label="seo 描述" prop="seo_description"> 
            <el-input type="textarea" v-model="formData.seo_description"></el-input>
          </el-form-item>
          <el-form-item label="是否热门" prop="is_hot"> 
            <el-switch v-model="formData.is_hot" :active-value="'1'" :inactive-value="'0'" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
          <el-form-item label="是否顶端导航" prop="is_top"> 
            <el-switch v-model="formData.is_top" :active-value="'1'" :inactive-value="'0'" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
          <I18nTranslatePanel entity-type="category" :entity-id="formData.id || ''" />
        </el-form>        
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
import Sortable from 'sortablejs'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    I18nTranslatePanel
  },
  data() {
    return {
      loadingStaus: true,
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      searchCondition:{
        "current_page": 1,
        "page_size": 20,
        "category_name":'',
        "category_status":'',
        "is_hot":'',
        "is_top":'',
        "order_by":"category_rank asc",
        "query":"pid=?",
        "params":["0"]
      },
      // 表格列表数据
      list:[],
      // element的cascader的props值
      cascaderProps:{
        multiple: true,
        label:'display_name',
        value:'id',
      },
      // 权限列表
      permissionsList:[],
      // 已选中的权限列表，用于cascader组件选中效果
      selectedList:[],
      menu_id:0,
      // 表单结构
      formData: {
        display_name:'',
      },
      // 表单验证
      rules: {
        display_name: [{required: true, message: '输入菜单名称', trigger: 'blur' }],
        url: [{required: false, message: '输入URL', trigger: 'blur' }],
        // selectedList: [{required: true, message: '选择权限', trigger: 'change', validator:this.cascaderVerify}]
      },
      // 定义表格拖拽排序
      sortable: null
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 响应添加按钮
    getNode(id){
      window.open('/cms/category/'+id,'_blank')
    },
    addButton(row = null) {
      let pid = '0'
      let depth = 0
      if (row) {
        pid = row.id
        depth = (row.depth || 0) + 1
      } else if (this.$route.params.id) {
        pid = this.$route.params.id
        depth = 1
      }
      this.dialogData.visible = true
      this.dialogData.title = pid && pid !== '0' ? '添加子分类' : '添加分类'
      // 保留所有表单字段，避免渲染异常
      this.formData = {
        ...this.formData,
        depth,
        pid: String(pid),
        id: '',
        category_name: '',
        category_link: '',
        category_icon: '',
        category_desc: '',
        seo_title: '',
        seo_keywords: '',
        seo_description: '',
        is_hot: '0',
        is_top: '0',
        category_status: '1'
      }
      this.dialogData.loading = false
    },
    // 重置搜索
    resetSearch() {
      this.searchCondition.category_name = ''
      this.searchCondition.category_status = ''
      this.searchCondition.is_top = ''
      this.searchCondition.is_hot = ''
      this.nodelist()
    },
    // 响应搜索按钮
    setSearchCondition(){
      this.searchCondition.params = []
      this.searchCondition.query = "pid=?"
      this.searchCondition.params.push(this.$route.params.id?this.$route.params.id:"0")
      if(this.searchCondition.category_name!=''){
        this.searchCondition.query+=" and category_name=?"
        this.searchCondition.params.push(this.searchCondition.category_name)
      }
      if (this.searchCondition.category_status!='' && this.searchCondition.category_status!=null){
        this.searchCondition.query+=" and category_status=?"
        this.searchCondition.params.push(this.searchCondition.category_status)
      }
      if (this.searchCondition.is_hot!=''){
        this.searchCondition.query+=" and is_hot=?"
        this.searchCondition.params.push(this.searchCondition.is_hot)
      }
      if (this.searchCondition.is_top!=''){
        this.searchCondition.query+=" and is_top=?"
        this.searchCondition.params.push(this.searchCondition.is_top)
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      this.formData.id = id
      this.dialogData.visible = true
      this.dialogData.title = '编辑菜单'
      let res= await this.$api.post('/service/ola_app_category/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }
      this.dialogData.loading = false
    },
    // 响应状态切换
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_category/update',row)
      if (this.$apiSuccess(res)){
        this.nodelist()
        this.$message.success('状态切换成功!')
      }
    },
    // form数据提交，请求接口
    async formSubmit() {
      let url = '/service/ola_app_category/create'
      if(this.formData.id!=undefined&&this.formData.id!=''){
        url = '/service/ola_app_category/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.nodelist()
        this.initData()
        this.$message.success('保存成功!')
      }
    },
    async nodelist(){
      this.loadingStaus=true
      this.setSearchCondition()
      let res= await this.$api.post('/service/ola_app_category/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.list=res.data.list
      }
      this.loadingStaus=false
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/category/delete',{id:id})
      if (this.$apiSuccess(res)){
        this.nodelist()
        this.$message.success('删除成功!')
      }else{
        this.$message.error(res.message || '删除失败!')
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['menuForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initData()
    },
    // 级联菜单自定义验证
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.selectedList = []
        this.formData = {
          system_permission_id:0,
          display_name:''
        }
        this.$refs['menuForm'].resetFields()
      })
    },
    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_category/order',{orderIds:orderIds,sort_field:'category_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.nodelist()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    }
  },
  async mounted() {
    this.nodelist()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 搜索卡片
.search-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .search-header
    margin-bottom 20px
    border-bottom 1px solid #f0f0f0
    padding-bottom 12px
    
    .search-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .search-content
    .search-form
      .form-row
        display flex
        flex-wrap wrap
        gap 16px
        align-items flex-end
        
        .form-item
          flex none
          margin-bottom 16px
          
          .input-wrapper
            /deep/ .el-input
              width 180px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            /deep/ .el-select
              width 150px
              
          .button-group
            display flex
            gap 8px
            
            .search-btn
              background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
              border none
              border-radius 8px
              padding 10px 20px
              font-weight 500
              box-shadow 0 2px 8px rgba(64,158,255,0.3)
              
              &:hover
                transform translateY(-1px)
                box-shadow 0 4px 12px rgba(64,158,255,0.4)
                
            .reset-btn
              border 2px solid #f0f0f0
              border-radius 8px
              padding 8px 18px
              color #606266
              background #fff
              
              &:hover
                border-color #409EFF
                color #409EFF

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0

// 表格单元格样式
.drag-wrapper
  .drag-handle
    display inline-flex
    align-items center
    justify-content center
    width 32px
    height 32px
    border-radius 6px
    background #f0f0f0
    color #909399
    cursor grab
    transition all 0.3s ease
    
    &:hover
      background #409EFF
      color #fff
      transform scale(1.1)
      
    &:active
      cursor grabbing

.category-cell
  .category-name
    font-size 16px
    font-weight 600
    color #303133
    margin-bottom 6px
    display flex
    align-items center
    gap 8px
    
    i
      color #67C23A
      
  .category-link
    font-size 14px
    color #909399
    display flex
    align-items center
    gap 6px
    
    i
      color #409EFF

.icon-cell
  .icon-display
    display flex
    align-items center
    justify-content center
    width 40px
    height 40px
    border-radius 8px
    background #f5f7fa
    margin 0 auto 8px
    
    i
      font-size 20px
      color #409EFF
      
    .no-icon
      font-size 12px
      color #909399
      
  .icon-code
    font-size 12px
    color #909399
    text-align center
    word-break break-all

.status-cell, .hot-cell, .top-cell
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .status-switch, .hot-switch, .top-switch
    /deep/ .el-switch__core
      border-radius 10px
      
  .status-text, .hot-text, .top-text
    font-size 12px
    color #909399
    display flex
    align-items center
    gap 4px
    
    i
      font-size 14px

.hot-cell
  .hot-text
    color #FF6B35
    
    i
      color #FF6B35

.top-cell
  .top-text
    color #409EFF
    
    i
      color #409EFF

.seo-cell
  .seo-item
    margin-bottom 6px
    font-size 14px
    
    &:last-child
      margin-bottom 0
      
    .seo-label
      color #909399
      font-weight 500
      
    .seo-value
      color #606266

.desc-cell
  display flex
  align-items flex-start
  gap 6px
  font-size 14px
  color #606266
  
  i
    color #909399
    margin-top 2px

.action-cell
  display flex
  gap 8px
  justify-content center
  
  .table-action-btn
    width 32px
    height 32px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.sub-btn
      background #E6A23C
      border-color #E6A23C
      
      &:hover
        background #F7BA2A
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(230,162,60,0.3)
        
    &.edit-btn
      background #409EFF
      border-color #409EFF
      
      &:hover
        background #66B3FF
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64,158,255,0.3)

// 响应式设计
@media (max-width: 1200px)
  .search-content
    .search-form
      .form-row
        .form-item
          .input-wrapper
            /deep/ .el-input
              width 160px
              
            /deep/ .el-select
              width 130px

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .search-card, .table-card
    padding 16px
    
  .search-content
    .search-form
      .form-row
        flex-direction column
        align-items stretch
        
        .form-item
          width 100%
          
          .input-wrapper
            /deep/ .el-input, /deep/ .el-select
              width 100%
              
  .action-cell
    flex-direction column
    gap 4px
</style>
